import React from 'react'
import Adminanalytics from '../../components/Admin/Adminanalytics'
import { adminAnalyticsUsers, AnalyticsTabs } from '../../utils/constants'
import { useSelector } from 'react-redux'
import { Tabs } from 'antd';

export default function Analytics() {
  const { user,isAdmin } = useSelector((state) => state.auth);
  return (isAdmin || adminAnalyticsUsers.includes(user.email)) ? <Adminanalytics /> : <Tabs items={AnalyticsTabs.map((item)=>{
	return {
		key: item.name,
		label: (
			<span className='flex items-center gap-3'> 
				{item.icon} {item.name}
			</span>
		),
		children: item.component,
	};
})}/>
}
